import { FC, useLayoutEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Typography, useMediaQuery } from '@mui/material';
import NavGroup from './NavGroup';
import { useMenuItems } from '../../../../../menu-items';
import useConfig from '../../../../../hooks/useConfig';
import { HORIZONTAL_MAX_ITEM } from '../../../../../config';
import { NavItemType } from '../../../../../types/menu';
import { MenuOrientation } from '../../../../../types/config';
import { useDebugMenuItems } from '../../../../../menu-items/debug';
import { useMenu } from '../../../../../store/menu';

const Navigation: FC = () => {
	const theme = useTheme();

	const downLG = useMediaQuery(theme.breakpoints.down('lg'));

	const { menuOrientation } = useConfig();
	const {
		state: { drawerOpen },
	} = useMenu();
	const [selectedItems, setSelectedItems] = useState<string | undefined>('');
	const [selectedLevel, setSelectedLevel] = useState<number>(0);
	const [menuItems, setMenuItems] = useState<{ items: NavItemType[] }>({ items: [] });
	const defaultMenuItems = useMenuItems();
	const debugMenuItems = useDebugMenuItems();

	useLayoutEffect(() => {
		setMenuItems(defaultMenuItems);
	}, [defaultMenuItems, debugMenuItems]);

	const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

	const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
	let lastItemIndex = menuItems.items.length - 1;
	let remItems: NavItemType[] = [];
	let lastItemId: string;

	//  first it checks menu item is more than giving HORIZONTAL_MAX_ITEM after that get lastItemid by giving horizontal max
	// item and it sets horizontal menu by giving horizontal max item lastly slice menuItem from array and set into remItems

	if (lastItem && lastItem < menuItems.items.length) {
		lastItemId = menuItems.items[lastItem - 1].id!;
		lastItemIndex = lastItem - 1;
		remItems = menuItems.items.slice(lastItem - 1, menuItems.items.length).map((item) => ({
			title: item.title,
			elements: item.children,
			icon: item.icon,
		}));
	}

	const navGroups = menuItems.items.slice(0, lastItemIndex + 1).map((item) => {
		switch (item.type) {
			case 'group':
				return (
					<NavGroup
						key={item.id}
						setSelectedItems={setSelectedItems}
						setSelectedLevel={setSelectedLevel}
						selectedLevel={selectedLevel}
						selectedItems={selectedItems}
						lastItem={lastItem!}
						remItems={remItems}
						lastItemId={lastItemId}
						item={item}
					/>
				);
			default:
				return (
					<Typography key={item.id} variant={'h6'} color={'error'} align={'center'}>
						{/* eslint-disable-line formatjs/no-literal-string-in-jsx */}
						Fix - Navigation Group
					</Typography>
				);
		}
	});
	return (
		<Box
			sx={{
				pt: drawerOpen ? (isHorizontal ? 0 : 2.5) : 0,
				'& > ul:first-of-type': { mt: 0 },
				display: isHorizontal ? { xs: 'block', lg: 'flex' } : 'block',
			}}
		>
			{navGroups}
		</Box>
	);
};

export default Navigation;
